import $ from 'jquery';

export default {
  init () {
    $('.events ,ripple-container').on('click', this.onClick)
  },
  onClick (e) {
    $(this).find('.ripple').css({
      left: e.offsetX + 'px',
      top: e.offsetY + 'px',
    }).addClass('animate')
  },
  
};
